<template>
    <div class="widget widget-primary">
        <div  v-if="myOffers.length > 0 ">
            <h3>{{ $translate("Woerner::Template.offersTitle") }}</h3>
        </div>
        <div class="order-history-list" v-if="myOffers.length > 0">
            <div class="container-header d-none d-md-flex mb-2">
                <div class="col-md-10">
                    <div class="row">
                        <div class="col-md-2 text-right">{{ $translate("Woerner::Template.offerConfirmationOrderId") }}</div>
                        <div class="col-md-2 text-right">{{ $translate("Ceres::Template.orderHistorySum") }}</div>
                        <div class="col-md-2 text-right">{{ $translate("Woerner::Template.offerConfirmationDate") }}</div>
                        <div class="col-md-2 text-right">&nbsp;</div>
                        <div class="col-md-4 text-right">{{ $translate("Ceres::Template.orderHistoryStatus") }}</div>
                    </div>
                </div>
                <div class="col-md-2">
                    {{ $translate("Woerner::Template.offersMore") }}
                </div>
            </div>
            <div class="order-item border-top">
                <div :id="'accordion_'+offer.order.id" class="accordion col-sm-12" v-for="(offer,index) in myOffers">
                    <div :id="'heading_'+offer.order.id" data-toggle="collapse" :data-target="'#collapse_'+offer.order.id" aria-expanded="false" :aria-controls="'collapse_'+offer.order.id" class="row container-clickable border-top-0 border py-3 collapsed">
                        <div class="col-md-10">
                            <div class="row">
                                <i class="fa fa-chevron-up"></i>
                                <div class="col-md-2">
                                    <div v-html="offer.order.id"></div>
                                </div>
                                <div class="col-md-2 text-right">
                                    <span>{{ $translate("Ceres::Template.orderHistoryTotal") }}</span>
                                    <span>
                                        {{ offer.order.amounts[0].netTotal | currency }}
                                    </span>
                                </div>
                                <div class="col-lg-2 text-right">
                                    <div v-html="offer.order.anlage"></div>
                                </div>
                                <div class="col-lg-2 text-right">
                                    &nbsp;
                                </div>
                                <div class="col-lg-4">
                                    {{ offer.order.statusName }}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="icons d-none d-md-block">
                                <a :href="'/bestellbestaetigung/?orderId='+offer.order.id+'&typ=angebot'" target="_blank" rel="noopener">
                                    <i aria-hidden="true" data-toggle="tooltip" data-placement="top" title="" class="fa fa-eye fa-flip-horizontal text-primary text-appearance"  v-tooltip data-original-title="Angebotdetails"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div :id="'collapse_'+offer.order.id" :data-parent="'#accordion_'+offer.order.id" class="collapse" style="">
                        <div class="row container-middle border-right border-left border-bottom">
                            <div class="col-lg-7 border-right">
                                <div class="cart-item row mt-3 align-items-center" v-for="(item,index) in offer.item" v-if="item.typeId != 6">
                                    <div class="col-12">
                                        <div class="row align-items-center">
                                            <div class="col-lg-2">
                                                <template v-for="offerVar in offer.variation">
                                                    <template v-if="item.itemVariationId == offerVar.id">
                                                        <img :src="offerVar.data.images.all[0].urlPreview" class="img-fluid">
                                                    </template>
                                                </template>
                                            </div>

                                            <div class="col-lg-10">
                                                <template v-for="offerVar in offer.variation">
                                                    <template v-if="item.itemVariationId == offerVar.id">
                                                        <a class="text-primary" v-html="item.orderItemName" :href="'/'+offerVar.data.texts.urlPath+'_'+offerVar.data.texts.itemId" target="_blank"></a>
                                                        <div class="row">
                                                            <strong class="col-6 col-sm-3 col-md-5">{{ $translate("Ceres::Template.basketItemNumber") }}</strong>
                                                            <span class="col-6 col-sm-9 col-md-7 text-right">{{ offerVar.data.variation.number }}</span>
                                                        </div>
                                                    </template>
                                                </template>
                                                <div class="item-details mt-0">
                                                    <div class="row">
                                                        <strong class="col-6 col-sm-3 col-md-5">{{ $translate("Ceres::Template.orderConfirmationPricePerPiece") }}</strong>
                                                        <span class="col-6 col-sm-9 col-md-7 text-right">{{ item.amounts[0].priceOriginalNet | currency }}</span>
                                                    </div>
                                                    <div class="row rebate-hint" v-if="(item.amounts[0].priceOriginalNet - item.amounts[0].priceNet) > 0 ">
                                                        <strong class="col-6 col-sm-3 col-md-5">{{ $translate("Ceres::Template.orderHistoryItemDiscount") }}</strong>
                                                        <span class="col-6 col-sm-9 col-md-7 text-right">{{ item.amounts[0].priceOriginalNet - item.amounts[0].priceNet | currency }}</span>
                                                    </div>
                                                    <div class="row">
                                                        <strong class="col-6 col-sm-3 col-md-5">{{ $translate("Ceres::Template.orderHistoryQuantity") }}</strong>
                                                        <span class="col-6 col-sm-9 col-md-7 text-right">{{ item.quantity }}</span>
                                                    </div>
                                                    <template v-for="offerVar in offer.variation">
                                                        <template v-if="item.itemVariationId == offerVar.id">
                                                            <template v-if="offerVar.data.attributes.length > 0">
                                                                <div class="row" v-for="attr in offerVar.data.attributes">
                                                                    <strong class="col-6 col-sm-3 col-md-5">{{ attr.attribute.names.name }}</strong>
                                                                    <span class="col-6 col-sm-9 col-md-7 text-right">{{ attr.value.names.name }}</span>
                                                                </div>
                                                                <div class="row">
                                                                    <strong class="col-6 col-sm-3 col-md-5">{{ $translate("Woerner::Template.basketUnit") }}</strong>
                                                                    <span class="col-6 col-sm-9 col-md-7 text-right">{{ offerVar.data.unit.names.name }}</span>
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <div class="row"><strong class="col-6 col-sm-3 col-md-5">{{ $translate("Ceres::Template.orderConfirmationTotal") }}</strong>
                                                        <strong class="col-6 col-sm-9 col-md-7 text-right">{{ item.amounts[0].priceNet * item.quantity | currency }}  </strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <div class="cmp cmp-totals pt-3 d-flex sticky-element mt-3">
                                    <div class="cmp cmp-totals">
                                        <h3>{{ $translate("Ceres::Template.orderHistorySum") }}</h3>
                                        <div>
                                            <dl class="d-flex flex-wrap">
                                                <template v-if="offer.rabat > 0">
                                                    <dt class="font-weight-bold">
                                                        {{ $translate("Ceres::Template.basketValue") }} ({{ $translate("Ceres::Template.checkoutNet") }})
                                                    </dt>
                                                    <dd class="font-weight-bold">
                                                        {{ offer.order.amounts[0].netTotal+offer.rabat | currency }}
                                                    </dd>
                                                    <dt class="rebate-hint">
                                                        {{ $translate("Ceres::Template.orderHistoryRebate") }}
                                                    </dt>
                                                    <dd class="rebate-hint">
                                                        {{ offer.rabat | currency }}
                                                    </dd>
                                                </template>
                                                <template v-else>
                                                    <dt class="font-weight-bold">
                                                        {{ $translate("Ceres::Template.basketValue") }} ({{ $translate("Ceres::Template.checkoutNet") }})
                                                    </dt>
                                                    <dd class="font-weight-bold">
                                                        {{ offer.order.amounts[0].netTotal | currency }}
                                                    </dd>
                                                </template>

                                                <dt class="font-weight-bold">
                                                    {{ $translate("Ceres::Template.orderHistoryShippingCosts") }} ({{ $translate("Ceres::Template.checkoutNet") }})
                                                </dt>
                                                <dd class="font-weight-bold">
                                                    <template v-if="offer.order.amounts[0].shippingCostsNet == 0">
                                                        {{ $translate("Woerner::Template.versandBerechnungLaeuft") }}
                                                    </template>
                                                    <template v-else>
                                                        {{ offer.order.amounts[0].shippingCostsNet | currency }}
                                                    </template>

                                                </dd>
                                                <hr class="w-100">
                                                <dt class="font-weight-bold">
                                                    {{ $translate("Ceres::Template.orderHistoryTotalSum") }} ({{ $translate("Ceres::Template.checkoutNet") }})
                                                </dt>
                                                <dd class="font-weight-bold">
                                                    {{ offer.order.amounts[0].netTotal | currency }}
                                                </dd>
                                                <div class="vatTotals d-flex w-100">
                                                    <dt>
                                                        MwSt. <span v-html="offer.order.amounts[0].vats[0].vatRate"></span> %
                                                    </dt>
                                                    <dd>
                                                        {{ offer.order.amounts[0].vats[0].value | currency }}
                                                    </dd>
                                                </div>
                                                <div class="totalSum d-flex w-100 flex-wrap">
                                                    <hr class="w-100">
                                                    <dt>
                                                        {{ $translate("Ceres::Template.orderHistoryTotalSum") }} ({{ $translate("Ceres::Template.orderHistoryGross") }})
                                                    </dt>
                                                    <dd>
                                                        {{ offer.order.amounts[0].grossTotal | currency }}
                                                    </dd>
                                                </div>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default
{
    props: ['template','user'],
    data: function()
    {
        return {
            customerOffers:[],
            page: 1,
            loading: false
        };
    },
    mounted: function()
    {
        let _self = this;
        _self.getOffers();
    },
    methods:
    {
        getOffers:function ()
        {
            let _self = this;
            let data = {
                "contactId" :this.user.id,
                "page":_self.page
            }
            $.ajax(
                {
                    type:           'POST',
                    url:            '/'+App.language+'/order/angebot/get/',
                    data:           data,
                    dataType:       'json',
                    success:        function(data)
                    {

                        for(let i=0; i<data.length;i++)
                        {
                            if(data[i].order.statusId!=6.8)
                            {
                                let itemRabats = 0;
                                for(let t = 0; t<data[i].order.orderItems.length;t++ )
                                {
                                    itemRabats += ((data[i].order.orderItems[t].amounts[0].priceOriginalNet - data[i].order.orderItems[t].amounts[0].priceNet)*data[i].order.orderItems[t].quantity);
                                }
                                data[i].rabat               = itemRabats;
                                data[i].zwischensummenetto  = data[i].order.amounts[0].netTotal - itemRabats;

                                data[i].zwischensummebrutto = data[i].zwischensummenetto+((data[i].zwischensummenetto/100)*data[i].order.amounts[0].vats[0].vatRate);

                                _self.customerOffers.push(data[i]);
                            }
                        }

                    },
                    error:          function(jqXHR, textStatus, errorThrown)
                    {
                        // console.error(errorThrown);
                    }
                });
        }
    },
    computed:
    {
        myOffers: function()
        {

            let _self = this;
            return _self.customerOffers
        }
    }
}
</script>